__turbopack_context__.v({
  "blue": "_0GXjzq_blue",
  "flag": "_0GXjzq_flag",
  "gray": "_0GXjzq_gray",
  "green": "_0GXjzq_green",
  "red": "_0GXjzq_red",
});
